module.exports = __webpack_public_path__ + "assets/img/new_my_music_icon.3f9748c0.png";